import React from 'react'
import director from '../resources/imteaj-head.jpg'
import { SocialLinks } from './StudentCard'

const TeamMemberCard = () => {
  return (
    <article className='director'>
      <div className='director__photo'>
        <img src={director} alt='Dr. Ahmed Imteaj' />
      </div>
      <div>
        <div className='eyebrow'>Lab Director</div>
        <p className='director__role'>
          Assistant Professor (Tenure-track) · Florida Atlantic University
        </p>
        <h3>Dr. Ahmed Imteaj</h3>
        <p>
          Dr. Ahmed Imteaj is a tenure-track Assistant Professor in the
          Department of Electrical Engineering and Computer Science at Florida
          Atlantic University, where he also serves as an I SENSE Faculty
          Fellow. Dr. Imteaj is the director of the Secure Prediction, Edge AI,
          and Multimodal LLM Lab (SPEED Lab). His research focuses on building
          secure, robust, and efficient AI systems, with an emphasis on Large
          Vision-Language Models, Federated Learning, Cybersecurity and Quantum
          AI. Dr. Imteaj is the recipient of multiple competitive research
          awards, including the NSF CRII Award, the NSF NAIRR Pilot, DHS CINA
          and ORAU Research Innovation Partnerships Grant.
        </p>
        <div className='director__links'>
          <a
            className='btn-pill btn-pill--solid'
            href='https://aimteaj.github.io/'
            target='_blank'
            rel='noreferrer'
          >
            Personal website <i className='fa-solid fa-arrow-right' />
          </a>
          <SocialLinks
            scholar='https://scholar.google.com/citations?user=I5IZ4GQAAAAJ&hl=en'
            LinkedIn='https://www.linkedin.com/in/ahmed-imteaj-a13343a3/'
            researchGate='https://www.researchgate.net/profile/Ahmed-Imteaj'
            orcid='https://orcid.org/0000-0002-6975-3997'
          />
        </div>
      </div>
    </article>
  )
}

export default TeamMemberCard
